import {ReactNode} from 'react';
import {Flex, Stack, VStack} from '@styled-system/jsx';
import {css} from '@styled-system/css';
import {h2} from '@styled-system/recipes';
import DiamondIcon from '../../icons/diamond.svg?react';
import WinnerNotificationIcon from '../../icons/winner-notification.svg?react';
import PhoneIcon from '../../icons/phone.svg?react';
import PresentIcon from '../../icons/present.svg?react';

const IconCircle = ({children}: { children: ReactNode }) => {
  return <Flex
    bga="red.900/5"
    width="48px"
    height="48px"
    justifyContent="center"
    alignItems="center"
    borderRadius="full"
    color="red.900"
  >
    {children}
  </Flex>
}

const Step = ({icon, title, description}: { icon: ReactNode, title: string, description: string }) => {
  return <VStack gap={{base: 4, lg: 8}} flex={1} textAlign="center" p={4}>
    <IconCircle>
      {icon}
    </IconCircle>
    <p className={css({
      fontFamily: 'heading',
      textTransform: 'uppercase',
      fontSize: 'xl',
      fontWeight: '500',
    })}>
      {title}
    </p>
    <p>
      {description}
    </p>
  </VStack>;
}


const WinnerSelection = () => {
  return (
    <VStack gap={8}>
      <h2 className={h2()}>
        How the winner is chosen
      </h2>
      <Stack
        direction={{base: "row", mdDown: 'column'}}
        gap={0}
        p={4}
        width="full"
        justifyContent="space-between"
        className={css({
          lg: {
            '& > div + div': {
              borderLeftWidth: '1px',
              borderColor: 'gray.200',
              borderStyle: 'solid',
            }
          },
          mdDown: {
            '& > div + div': {
              borderTopWidth: '1px',
              borderColor: 'gray.200',
              borderStyle: 'solid',
            }
          }
        })}
      >
        <Step
          icon={<DiamondIcon/>}
          title="1. Entry Processing"
          description="Entries are collected and counted (Takes 7 business days after the giveaway ends)"
          />

        <Step
          icon={<PresentIcon/>}
          title="2. Winner Selection"
          description="A random winner is selected by our third-party sweepstakes company, American-Sweeps.com."
        />

        <Step
          icon={<WinnerNotificationIcon/>}
          title="3. Winner Notification"
          description="The winner is notified via text message (so check your cell phones and add our contact card to your address book!)"
        />

        <Step
          icon={<PhoneIcon/>}
          title="4. Delivery of the prize"
          description="After all appropriate paperwork is completed, prize is delivered (up to 30 days after winner is notified)."
        />
      </Stack>
    </VStack>
  );
};

export default WinnerSelection;
